import EventosHeader from "../components/Eventos/EventosHeader";
import AcreditacionTabs from "../components/Eventos/AcreditacionTabs";
import EventosGrid from "../components/Eventos/EventosGrid";
import { useFetchFree } from "../hooks";
import Loading from "../components/Loading";
import { useState, useCallback } from "react";
import Disclaimer from "../components/Eventos/Disclaimer";

const Eventos = () => {
  const partidosRes = useFetchFree("/eventos");
  const categoriasRes = useFetchFree("/deportes");
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [selectedSubCategoria, setSelectedSubCategoria] = useState(null);
  const [tipoAcreditacion, setTipoAcreditacion] = useState("medios");
  const [gridVisible, setGridVisible] = useState(true);

  const { data: eventos, isLoading: eventosLoading } = partidosRes;
  const { data: categorias, isLoading: categoriasLoading } = categoriasRes;

  const handleTabChange = useCallback((tipo) => {
    if (tipo === tipoAcreditacion) return;
    setGridVisible(false);
    setTimeout(() => {
      setTipoAcreditacion(tipo);
      setGridVisible(true);
    }, 200);
  }, [tipoAcreditacion]);

  return (
    <div>
      <section className="partidos-header general-container">
        <Disclaimer mensajeConmebol={eventos?.mensajeConmebol} />
        <h1>
          Mirá los próximos eventos,
          <br /> hace tu solicitud de acreditación.
        </h1>
        <p>Podés filtrar los resultados dependiendo del evento que cubrirás.</p>
      </section>
      {eventosLoading || categoriasLoading ? (
        <Loading />
      ) : (
        <>
          {categorias && (
            <EventosHeader
              categorias={categorias.data}
              selectedCategoria={selectedCategoria}
              setSelectedCategoria={setSelectedCategoria}
              selectedSubCategoria={selectedSubCategoria}
              setSelectedSubCategoria={setSelectedSubCategoria}
            />
          )}
          <AcreditacionTabs value={tipoAcreditacion} onChange={handleTabChange} />
          <div style={{ opacity: gridVisible ? 1 : 0, transition: "opacity 0.2s ease" }}>
            {eventos?.data.length > 0 ? (
              <EventosGrid
                eventos={eventos.data}
                selectedCategoria={selectedCategoria}
                selectedSubCategoria={selectedSubCategoria}
                tipoAcreditacion={tipoAcreditacion}
              />
            ) : (
              <h5 className="no-eventos">No hay eventos disponibles en este momento.</h5>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Eventos;
